<footer class="py-5 bg-dark">
  <div class="container">
    <p class="mb-5 text-center text-white contact" routerLink="contact">
      <i class="bi bi-envelope me-2"></i>Contatc Us
    </p>
    <p class="m-0 text-center text-white">Copyright © {{ date }}</p>
  </div>
</footer>
